export class LocalizationConstants {
    public static DEFAULT_TIMEZONE_ID = (): string => 'Eastern Standard Time';
    public static DEFAULT_CURRENCY_ID = (): number => 8;
    public static DEFAULT_MINOR_UNITS = (): number => 100;
}
